<mat-sidenav-container>
    <mat-sidenav-content>
        <div id="container">
            <mat-card appearance="outlined" class="mat-elevation-z8">
                <div class="row gx-0">

                    <div id="container-login">
                        <mat-card-title>
                            <img class="responsive" [src]="logos" src="" alt="" />
                        </mat-card-title>
                        <mat-divider class="d-lg-none" inset></mat-divider>
                        <mat-card-title>
                            <h3>Validación de correo activo</h3>
                        </mat-card-title>
                        <mat-card-content>
                            {{message}}
                            <mat-card-actions>
                                <button mat-raised-button color="primary" type="button" (click)="cancelar()">
                                    <mat-icon>close</mat-icon>
                                    <span>Aceptar</span>
                                </button>
                            </mat-card-actions>
                        </mat-card-content>
                    </div>

                </div>
            </mat-card>
        </div>

    </mat-sidenav-content>
</mat-sidenav-container>